import apiClient from "../utils/apiClient";
import { useMutation, useQuery, useQueryClient } from "react-query";

import Swal from "sweetalert2";
import { useMyContext } from "../context";
import { useNavigate } from "react-router-dom";
import useFilter from "./useFilter";

const useEmployees = ({ employeeId } = {}) => {
  const { search, page } = useFilter();
  const navigate = useNavigate();

  const queryClient = useQueryClient();
  const {
    handleCloseModal,
    showErrorAlert,
    employeeData,
    id,
    setId,
    setEmployeeData,
    setMode,
  } = useMyContext();
  const idEmployee = employeeId || id;
  const { data, error, isError, isLoading } = useQuery({
    queryKey: ["employees", search, page],
    queryFn: async () => {
      const res = await apiClient.get(
        `/dashboard/admins?search=${search}&page=${page}`,
      );
      return res.data;
    },
  });
  // get employee by id
  const { data: employeeById, isLoading: employeeByIdLoading } = useQuery({
    queryKey: ["employeeById", idEmployee],
    queryFn: async () => {
      const res = await apiClient.get(`/dashboard/admins/${idEmployee}`);
      return res.data;
    },
    enabled: !!idEmployee,
  });
  // add update employee
  const addUpdateEmployee = useMutation({
    mutationFn: async () => {
      const employeeFormData = new FormData();
      const selectedPhoto = employeeData?.photo;

      // In create mode, photo must be a valid image file
      if (!id) {
        if (!(selectedPhoto instanceof File)) {
          throw new Error("Please select an employee photo");
        }
        if (!selectedPhoto.type?.startsWith("image/")) {
          throw new Error("Selected file must be an image");
        }
      }

      // In update mode, if a new photo is provided it must be an image
      if (id && selectedPhoto && !(selectedPhoto instanceof File)) {
        throw new Error("Invalid photo file");
      }
      if (id && selectedPhoto instanceof File && !selectedPhoto.type?.startsWith("image/")) {
        throw new Error("Selected file must be an image");
      }

      employeeFormData.append("name", employeeData?.name);
      employeeFormData.append("phone_number", employeeData?.phone_number);
      employeeData?.password &&
        employeeFormData.append("password", employeeData?.password);
      employeeFormData.append("role_id", employeeData?.role_id);
      if (selectedPhoto instanceof File) {
        employeeFormData.append("photo", selectedPhoto);
      }
      id && employeeFormData.append("active", employeeData.active);
      id && employeeFormData.append("_method", "PUT");
      console.log(employeeFormData, idEmployee);
      const url = id ? `/dashboard/admins/${idEmployee}` : "/dashboard/admins";
      const res = await apiClient.post(url, employeeFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-Skip-Encryption": "true",
        },
      });
      return res.data;
    },
    onSuccess: () => {
      const message = id
        ? "Employee Updated Successfully"
        : "Employee Created Successfully";
      Swal.fire({
        icon: "success",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
      queryClient.invalidateQueries({ queryKey: ["employees"] });
      handleCloseModal("addEditEmployee");
      employeeId && navigate("/employees");
      setId("");
      setEmployeeData({
        name: "",
        phone_number: "",
        password: "",
        role_id: 0,
        photo: undefined,
        active: 1,
      });
      setMode("add");
    },
    onError: (err) => {
      showErrorAlert(err, "error");
    },
  });
  const addupdateEmployeeLoading = addUpdateEmployee.isLoading;
  const handleAddUpdateEmployee = () => {
    addUpdateEmployee.mutate();
  };
  // delete employee
  const deleteEmployee = useMutation({
    mutationFn: async () => {
      const res = await apiClient.delete(`/dashboard/admins/${idEmployee}`);
      return res.data;
    },
    onSuccess: () => {
      Swal.fire({
        icon: "success",
        title: "Employee deleted successfully",
        showConfirmButton: false,
        timer: 1500,
      });
      queryClient.invalidateQueries({ queryKey: ["employees"] });
      handleCloseModal("delete");
      employeeId && navigate("/employees");
    },
    onError: (err) => {
      showErrorAlert(err, "error");
    },
  });
  const deleteEmployeeLoading = deleteEmployee.isLoading;
  const handleDeleteEmployee = () => {
    deleteEmployee.mutate();
  };
  return {
    data,
    error,
    isError,
    isLoading,
    addupdateEmployeeLoading,
    handleAddUpdateEmployee,
    employeeById,
    deleteEmployeeLoading,
    handleDeleteEmployee,
    employeeByIdLoading,
  };
};

export default useEmployees;
